import React from "react";


function Logo({ children, ...restProps }) {
  return (
    <div className="my-2 text-center  text-3xl">
      <a href="/" {...restProps}>
        {children}

        <span className=" text-blue-500 font-semibold">{'<'}</span>
        <span className="text-gray-900 font-semibold text-3xl leading-7"> Hafiz</span>
        <span className=" text-blue-500 font-semibold">{' />'}</span>
      </a>
      <div className="text-gray-500 text-lg">Full Stack Developer</div>
    </div>

  );
}

export default Logo;